import { GoogleOAuthProvider } from "@react-oauth/google";
import Login from "./Login";
const clientId = "77960450565-6jc2hto8d5l9lsgc1kacvkfe91lptf4d.apps.googleusercontent.com";

export default function GoogleOAuth() {
    return (
        <GoogleOAuthProvider clientId={clientId}>
            <Login />
        </GoogleOAuthProvider>
    )
}
